import React, { Component } from 'react';

//components
import CariPositionPanel from "./CariPositionPanel";

//generic functions
import {
    isEmpty
} from "../../../../functions/generic_functions";

/*
    props:
        positionList => contains a list of position information and includes application data per position
        selectPositionFunc => passed in function to set the active position
*/

class CariMultiPositionPanel extends Component {
    
    state = { 
        currPositionIdShown: undefined,
    }

    constructor(props) {
        super(props);

        //action handlers
        this.handleOnClickShowPanel = this.handleOnClickShowPanel.bind(this);
        this.getContinuingPositionList = this.getContinuingPositionList.bind(this);
        this.getNonContinuingPositionList = this.getNonContinuingPositionList.bind(this);
    }
  
    handleOnClickShowPanel(positionId, visibility) {
        if(!visibility) {
            positionId = undefined;
        }
        this.setState({
            currPositionIdShown: positionId,
        })
    }

    getContinuingPositionList() {
        const continuing = this.props.positionList.filter((value) => value.is_non_continuing === "0");
        const continuingList = continuing.length > 0 ? continuing.map((currPosition, i) => {
            return (
                <div key={i}>
                    <CariPositionPanel
                        positionData = {currPosition}
                        onClickShowPanel={this.handleOnClickShowPanel}
                        visibility={(currPosition.position_id === this.state.currPositionIdShown) ? true : false}
                        match={this.props.match}
                        selectPositionFunc={this.props.selectPositionFunc}
                    />
                </div>
            )
        }) : null;

        return continuingList;
    }

    getNonContinuingPositionList() {
        const nonContinuing = this.props.positionList.filter((value) => value.is_non_continuing === "1");
        const nonContinuingList = nonContinuing.length > 0 ? nonContinuing.map((currPosition, i) => {
            return (
                <div key={i}>
                    <CariPositionPanel
                        positionData = {currPosition}
                        onClickShowPanel={this.handleOnClickShowPanel}
                        visibility={(currPosition.position_id === this.state.currPositionIdShown) ? true : false}
                        match={this.props.match}
                        selectPositionFunc={this.props.selectPositionFunc}
                    />
                </div>
            )
        }) : null;

        return nonContinuingList;
    }

    render() { 
        return ( 
            <div>
                {
                    (!isEmpty(this.props.positionList) && this.props.positionList.filter((value) => value.is_non_continuing === "0").length > 0) 
                    ? <div>
                        <label className="is_non_continuing">Continuing</label>
                        <br/>
                        {this.getContinuingPositionList()}
                      </div> 
                    : null
                }
                <br/><br/>
                {
                    (!isEmpty(this.props.positionList) && this.props.positionList.filter((value) => value.is_non_continuing === "1").length > 0) 
                    ? <div>
                        <label className="is_non_continuing">Non-Continuing</label>
                        <br/>
                        {this.getNonContinuingPositionList()}
                      </div> 
                    : null
                }
            </div>
        );
    }
}
 
export default CariMultiPositionPanel;